import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import type { EditorConfig } from 'https://cdn.ckeditor.com/typings/ckeditor5.d.ts';

@Injectable({
    providedIn: 'root'
})
export class TextService {

    /**
     * API URL
     */
    private API_URL: string;

    /**
     * PREFIX URL
     */
    private readonly PREFIX_URL: string = '/text';

    private _editor: any;

    private _ckeditorConfig: EditorConfig;

    /**
     * @param _http
     */
    constructor(private _http: HttpClient) {

    }

    /**
     * Définit l'URL d'accès à l'API
     *
     * @param apiUrl
     */
    public setApiUrl(apiUrl: string): void {

        this.API_URL = apiUrl;
    }


    /**
     * Retourne l'api prefix
     */
    public getApiUrl(withPrefix: boolean): string {

        if (withPrefix) {
            return this.API_URL + this.PREFIX_URL;
        }

        return this.API_URL;
    }

    get editor(): any {

        return this._editor;
    }

    set editor(value: any) {

        this._editor = value;
    }

    get ckeditorConfig(): EditorConfig {

        return this._ckeditorConfig;
    }

    set ckeditorConfig(value: EditorConfig) {

        this._ckeditorConfig = value;
    }
}
